

export const ACTION_LIST_PRODUCTS = "ACTION_LIST_PRODUCTS";
export const ACTION_DETAIL_PRODUCT = "ACTION_DETAIL_PRODUCT";
export const ACTION_LIST_PRODUCTS_CLIENT = "ACTION_LIST_PRODUCTS_CLIENT";
export const ACTION_LIST_PRODUCTS_FILTER_TYPE_PRODUCT = "ACTION_LIST_PRODUCTS_FILTER_TYPE_PRODUCT";
export const ACTION_LIST_NUMBER_CONTRACT_FILTER_COMPANY = "ACTION_LIST_NUMBER_CONTRACT_FILTER_COMPANY";
export const ACTION_POLICY_PRODUCT = "ACTION_POLICY_PRODUCT";
export const ACTION_DIALOG_ACTIVE = "ACTION_DIALOG_ACTIVE";

export const ACTION_GET_PRODUCTS = "ACTION_GET_PRODUCTS";
export const ACTION_POST_CREATE_PRODUCTS = "ACTION_POST_CREATE_PRODUCTS";
export const ACTION_PUT_UPDATE_PRODUCTS = "ACTION_PUT_UPDATE_PRODUCTS";
export const ACTION_DELETE_DELETE_PRODUCTS = "ACTION_DELETE_DELETE_PRODUCTS";
export const ACTION_GET_PRODUCT_BY_ID = "ACTION_GET_PRODUCT_BY_ID";
export const ACTION_GET_LIST_COUNTRY = "ACTION_GET_LIST_COUNTRY";

